const zh = {
  message: {
    language: '语言切换',
    home: '公司首页',
    ABOUTGROUP: '企业概括',
    business: '集团业务',
    news: '新闻中心',
    JoinUs: '加入我们',
    InvestorRelations: '投资互动'
  },
  footer: {
    '1-1': '隐私说明',
    '1-2': '版权声明',
    '1-3': '联系我们',
    '1-4': '网站地图',
    '1-5': '电话',
    '1-6': '邮箱',
    '1-7': '地址',
    '1-8': '上海市松江区莘砖公路518号10幢',
    '1-9': '官方微信',
    '1-10': '© 2017 天海融合防务装备技术股份有限公司 版权所有 沪ICP备14054780号-1'
  },
  home: {
    '1-1': '管理与业务，造就企业发展之帆',
    '1-2': ' 年',
    '1-3': '天海融合防务装备技术股份有限公司创于2001年',
    '1-4': '国家首批创业板上市企业',
    '1-5': '收购上海沃金天然气利用有限公司',
    '1-6': '收购泰州市金海运船用设备有限责任公司',
    '1-7': '收购江苏大津重工有限公司',
    '1-8': '新战略目标实施',
    '2-1': '管理与业务，造就企业发展之帆',
    '2-2': '天海防务始终以人为本，在自主培养和引进相结合下，形成了合理的人才结构和科学的管理体系，并通过一流的服务与真诚的合作打造出“一总部三平台”的业务构架。天海防务以完备的组织与业务架构，造就了企业的发展之帆，成为了国内上市公司中极具创新活力的特色化企业集团。',
    '2-3': '行业内唯一集船舶设计与建造为一体的综合解决方案提供商，现金防务装备研发与制造供应商，新能源综合服务运营商',
    '3-1': '公司新闻',
    '3-2': '行业新闻',
    '3-3': '生产速递',
    '3-4': '船市信息',
    '3-5': '查看更多'
  },
  group: {
    '1-1': '发展战略与企业文化',
    '1-2': '以企业发展战略为导向，建立锐意进取、开拓创新、争做一流的企业文化，积极承担社会责任与环境责任，实现企业综合实力的全面提升'
  },
  business: {
    '2-1': '船舶与海洋工程EPC业务平台',
    '2-2': '业务架构',
    '2-3': '船舶设计',
    '2-4': '船舶与海洋工程总装基地',
    '2-5': '海工产品&钢结构制造基地',
    '2-6': '船舶技术咨询与工程监理',
    '2-7': '虚拟仿真造船平台',
    '2-8': '主要业绩',
    '2-9': '作为天海防务的核心板块和人才高地，聚集了来自行业内各设计 研究院所、船级社、船厂、航公司、海事部门、设备厂商等知名 企业的专业人才组成的核心技术团队。',
    '2-10': '江苏大津重工有限公司',
    '2-11': '位于江苏省扬中市，距长江入海口180公里，东邻长江 主航道，西连沪宁高速， 。有着优越地理位置与水深条件。占地 面积约60余万平方米，长江水域岸线长度约2.5公里。拥有舾 装码头长1000米， 配备50000吨半船坞 座， 30000吨室内船台 一座。是船舶与海洋工程总承包琐目的建造基地和数字化虚拟 造船平台的实现终端',
    '2-12': 'IS09001 质量管理体系、1S014001环境管理体系OHSAS18001职 业健康安全管理体系 中国船舶工业协会第五届会员单位， 工信部《船舶行业规范条件》企业名单(造船白名单）、江苏 省省级企业技术中心、国家高新技术企业，交通运输部LNG动 力船建造示范单位 主航道，西连沪宁高速， 。有着优越地理位置与水深条件。占地 面积约60余万平方米，长江水域岸线长度约2.5公里。拥有舾 装码头长1000米， 配备50000吨半船坞 座， 30000吨室内船台 一座。是船舶与海洋工程总承包琐目的建造基地和数字化虚拟 造船平台的实现终端',
    '2-13': '泰州泰船重工装备有限公司',
    '2-14': '大津重工旗下的总装基地，拥有共享1~5万吨级船台多座，门吊最大起重能力500T，施工场地、码头、生产配套、仓储运输等设施齐备',
    '2-15': '主要业务范围',
    '2-16': '与大津重工相同，涵盖各类绿色运输船舶、海洋工程船舶、中小型油化气船、集装箱船、 公务船、特种船，钢制/铝合金小型船艇、各类大型桥梁钢结构等的制造以及船用新能源系统的总装集成。',
    '2-17': '江苏佳美海洋工程装备有限公司成立于2 0 15年，位于江苏扬中市长江主航道苏南侧 紧邻沪宁高速，地理位置优越通便利。公司主要产品为圆柱型桩腿、桩靴、桁架式桩、重型钢结构、凤电塔简、 气罐、发酵罐等',
    '2-18': '公司古地面积500余亩，拥有270米涉外万吨级码头一座，配备150吨、280吨等重型起重机',
    '2-19': '拥有1s09001质量管理体 系和OHSAS18001职业健康安全管理体系证书',
    '2-20': '上海佳船工程监理发展有限公司',
    '2-21': '中国设各监理协会副理事长单位．具有工程设备监理甲级资质。本着客户至上理念，公司为国内外客户提供各种工程咨询和工程监理服务',
    '2-22': '散货船，集装箱船， 化学品船，公务船， 海洋工程船，科考船等高附加值船舶。是国内前三甲海事专业工程设备监理公司。',
    '2-23': '三维数字化虚拟造船平台',
    '2-24': '通过全三维化软件设计，录入制造厂底层数据，配合成本预控平台，精确指导船厂实现数字化造船。通过一体化三维设计，对工艺及建造进行仿真，形成设计库和制造库数据流，以数字化管理构建三维虚拟造船平台；以“中间产品为导向， 壳舾涂体化，精益造船” 的现代造船模式，在前期“虚拟造船平台”中解决好项目设计方案的细化确定、船东船检评审审图、物资设备采购、具体生产计划节点等统筹安排、全面落实后，在船厂 ‘现场建造平台”开展项目的组织管理与生产实施。',
    '2-25': '国内最大深潜工作母船《500米饱和潜水6000米水下机器人）',
    '2-26': '世界最大12000吨起重能力全回转单体起重船；',
    '2-27': '国内边检系统最大50米巡逻艇；',
    '2-28': '国内最大双体式整体风电运揄安装船；',
    '2-29': '国内最大内贸4000TEU集装箱船',
    '2-30': '国内首创12000吨抬浮力打捞船',
    '2-31': '国内最大海洋溢油回收船',
    '2-32': '国內首创深层搅拌工作船',
    '2-33': '国内最大工作水深海工辅助平台',
    '2-34': '世界首艘双燃料港作拖轮',
    '2-35': '亚洲首艛纯夭然气港作拖轮',
    '2-36': '国内首创无人救生艇',
    '2-37': '最大引航工作母船'
  }
}

export default zh
